export const getAppEmptyResponse = city => ({ areaSlug: city });

function isValidDate(moveOut) {
  if (moveOut === null || moveOut === undefined) {
    return true;
  }

  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(moveOut)) {
    return false;
  }

  const date = new Date(moveOut);
  return date.toISOString().startsWith(moveOut);
}

export const buildAppData = ({
  isFavorite,
  internalLinking,
  query,
  rentableUnitData,
  listingStatistics
}) => {
  const { areaSlug, seo, listing } = rentableUnitData;
  let moveIn;
  let moveOut;

  if (query) {
    moveIn = isValidDate(query['move-in']) ? query['move-in'] : '';
    moveOut = isValidDate(query['move-out']) ? query['move-out'] : '';
  }

  const parsedOffers = listing.offers.filter(Boolean);
  return {
    areaSlug,
    seo,
    internalLinking,
    isFavorite,
    listing: {
      ...listing,
      offers: parsedOffers,
      hasOffer: !!parsedOffers.length,
      statistics: listingStatistics || {}
    },
    moveIn,
    moveOut
  };
};

export default { getAppEmptyResponse, buildAppData };
